export function redirectToUnauthorized() {
  if (window.location.pathname === "/unauthorized") {
    return;
  }

  window.history.pushState({}, "", "/unauthorized");
  window.dispatchEvent(new Event("popstate"));
}
